/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import SurveyDoneScene from '@/modules/survey/scenes/survey-done.scene.vue';
import SurveyStep1Scene from '@/modules/survey/scenes/survey-step-1.scene.vue';
import SurveyStep2Scene from '@/modules/survey/scenes/survey-step-2.scene.vue';

/**
 * Routes.
 */
export default [
  {
    alias: 's/:key',
    component: SurveyStep1Scene,
    name: 'SurveyStep1',
    path: 's/1/:key'
  },
  {
    component: SurveyStep2Scene,
    name: 'SurveyStep2',
    path: 's/2/:key',
    props: true
  },
  {
    component: SurveyDoneScene,
    name: 'SurveyDone',
    path: 's/done/:key',
    props: true
  }
] as RouteConfig[];
